import AgenticLanding from '@/components/home/AgenticLanding';

export default function HomePage() {
  return <AgenticLanding />;
}
